import { Component, OnInit } from '@angular/core';
import { BreederInfo } from '../../classes/breeder';
import { BreederInfoReward } from 'src/app/classes/breeder-info-reward';
import { BreederService } from 'src/app/services/breeder.service';
import { Dog } from 'src/app/classes/dog';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit {
  public showPopup = false;
  public breederData: BreederInfo = null;
  public points: number;
  public pointsLevel: string;
  public toClaimReward: BreederInfoReward;
  public dogs: Dog[] = [];
  public yearFilters: number[] = [];
  public selectedYearFilter = null;

  constructor(
    public glService: GlobalService,
    private _breederSvc: BreederService
  ) { }

  ngOnInit() {
    this._breederSvc.getBreederInfo().subscribe(result => {
      this.breederData = Object.assign({}, result);
      this.breederData.pointsRankName = this._breederSvc.getLevelAccordingToPoints(result.points);
    });

    this._breederSvc.getMyDogs().subscribe(res => {
      const yearList = [];
      this.dogs = res;
      this.dogs.forEach(dog => {
        const dateObj = new Date(dog.birthDate);
        yearList.push(dateObj.getFullYear());
      });
      this._setDogsDateOfBirth();
      this.yearFilters = Array.from(new Set(yearList));
    });
  }

  public popupVisible(toClaimReward: BreederInfoReward): void {
    this.showPopup = true;
    this.toClaimReward = toClaimReward;
  }

  public setClaimed(): void {
    this.breederData.rewards.some(reward => {
      if (this.toClaimReward.rewardId === reward.rewardId) {
        reward.claimed = true;
        return true;
      }
    });
  }

  public popupClose(event): void {
    if (event) {
      // Close popup if click is on background, keep open if click is on popup
      if (event.target === event.currentTarget) {
        this.showPopup = false;
        this.toClaimReward = null;
      }
    } else {
      this.showPopup = false;
      this.toClaimReward = null;
    }
  }

  public requestPups(): void {
    this._breederSvc.getMyDogs(this.selectedYearFilter).subscribe(res => {
      this.dogs = res;
      this._setDogsDateOfBirth();
    });
  }

  private _setDogsDateOfBirth(): void {
    this.dogs.forEach(dog => {
      const dateObj = new Date(dog.birthDate);
      dog.birthDate = `${dateObj.getDate()}/${dateObj.getMonth() + 1}/${dateObj.getFullYear()}`;
    });
  }

}
